<script>
	import {
		Modal,
		ModalBody,
		Button,
		Row,
		Col,
		Alert,
	} from "@sveltestrap/sveltestrap";
	import { warningModalOpen } from "../../store/store";
	import { onDestroy } from "svelte";
	import FontAwesomeIcon from "src/components/FontAwesomeIcon/FontAwesomeIcon.svelte";
	import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

	export let onClose;
	export let carEfficiency;
	export let createCarError;

	let open;

	warningModalOpen.subscribe((val) => {
		open = val;
	});

	const toggle = () => {
		if (onClose) {
			onClose();
		} else {
			warningModalOpen.set(false);
		}
	};

	onDestroy(() => {
		warningModalOpen.set(false);
	});
</script>

<div>
	<Modal isOpen={open}>
		<ModalBody>
			<Row>
				<Col>
					<Row>
						<Col xs={12}>
							{#if carEfficiency}
								<Alert color="success">
									<Row>
										<Col xs={2}>
											<div class="icon mx-auto mt-2">
												<FontAwesomeIcon
													icon={faInfoCircle}
												/>
											</div>
										</Col>
										<Col>
											<Row>
												<span><b>Success</b></span>
											</Row>
											<Row>
												<span>Car efficiency added</span
												>
											</Row>
										</Col>
									</Row>
								</Alert>
							{/if}
							{#if createCarError}
								<Alert color="danger">
									<Row class="align-items-center">
										<Col xs={2}>
											<div
												class="big-icon mx-auto my-auto"
											>
												<FontAwesomeIcon
													icon={faInfoCircle}
												/>
											</div>
										</Col>
										<Col>
											<Row>
												<span><b>Missing Data</b></span>
											</Row>
											<Row>
												<p class="mb-3">
													The following input fields
													are missing data and need to
													be filled out via Master
													Data > Vehicle Master Data >
													Car efficiency:
												</p>

												<ul class="data-list">
													<li>
														Max. EV distance (km)
													</li>
													<li>
														Fuel (L)/Battery
														Efficiency (kWh)
													</li>
													<li>
														Fuel/Battery Capacity
														(km)
													</li>
												</ul>
											</Row>
										</Col>
									</Row>
								</Alert>
							{/if}
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<div class="mt-1">
								<Button
									class="themeButton primary px-2"
									block
									on:click={toggle}
								>
									OK
								</Button>
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
		</ModalBody>
	</Modal>
</div>

<style>
	.icon {
		width: 27px;
		height: 27px;
	}

	.big-icon {
		width: 40px;
		height: 40px;
	}

	.icon :global(svg),
	.big-icon :global(svg) {
		width: 100%;
		height: 100%;
	}

	.data-list {
		list-style: disc; /* Use bullet points */
		padding-left: 20px; /* Adjust spacing for bullet points */
	}
</style>
